import { render, staticRenderFns } from "./FieldsChecklist.vue?vue&type=template&id=143c274c&scoped=true"
import script from "./FieldsChecklist.vue?vue&type=script&lang=js"
export * from "./FieldsChecklist.vue?vue&type=script&lang=js"
import style0 from "./FieldsChecklist.vue?vue&type=style&index=0&id=143c274c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c274c",
  null
  
)

export default component.exports